import { Link } from 'react-router-dom';
import type { FooterLink } from './useFooterData';

interface FooterLinkItemProps {
  link: FooterLink;
  /** Variants pass their own colour scheme; default = the dark-band footer. */
  className?: string;
}

const DARK_BAND_CLASS =
  'text-sage-300 hover:text-white transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400 rounded';

/** One footer link: an Axiss opener or a router link. */
export default function FooterLinkItem({ link, className = DARK_BAND_CLASS }: FooterLinkItemProps) {
  if (link.axissOpen) {
    return (
      <button data-axiss-open={link.axissView || 'home'} className={className}>
        {link.label}
      </button>
    );
  }
  return (
    <Link to={link.href || '#'} className={className}>
      {link.label}
    </Link>
  );
}
